import { NAV_SIDEBAR_ELEMENT_ID } from '@modules/leftNavSidebar/constants';
import { useEffect, useState } from 'react';

const FALLBACK_VALUE = 86;

export default function useGetNavSidebarWidth(): number {
  const [navSidebarWidth, setNavSidebarWidth] = useState(FALLBACK_VALUE);

  useEffect(() => {
    const navSidebarElement = document.getElementById(NAV_SIDEBAR_ELEMENT_ID);
    setNavSidebarWidth(navSidebarElement?.clientWidth || FALLBACK_VALUE);
  }, []);

  return navSidebarWidth;
}
